import React, { useEffect, useRef } from "react";

const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;

const wrapperStyle = {
  margin: "2rem auto",
  maxWidth: 680,
  textAlign: "center",
  padding: "0.85rem",
  background: "var(--bg)",
  border: "1px solid var(--line)",
  borderRadius: 12,
  minHeight: 100,
  boxSizing: "border-box",
};

const labelStyle = {
  display: "block",
  fontSize: "0.68rem",
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "var(--ink-700)",
  opacity: 0.55,
  marginBottom: 8,
  fontWeight: 700,
};

/**
 * A single, restrained in-article ad slot. Renders nothing at all — in dev or in
 * production — until REACT_APP_ADSENSE_CLIENT and a real ad slot ID are both
 * configured, so nothing ad-related is visible anywhere until monetization is
 * actually turned on. See .env for how to activate it later.
 */
export default function AdUnit({ slot, label = "Advertisement" }) {
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!ADSENSE_CLIENT || !slot) return;
    if (pushedRef.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (e) {
      // Ad blockers or a not-yet-loaded script land here. Must never break the page.
    }
  }, [slot]);

  if (!ADSENSE_CLIENT || !slot) return null;

  return (
    <div style={wrapperStyle}>
      <span style={labelStyle}>{label}</span>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
